import { css } from 'styled-components';

export const visualDiffHoverStyleRegular = css`
  opacity: 1;
  stroke: hsl(0, 0%, 85%) !important;
  transition: stroke 0.25s ease-out;
  &:not(.parent-child-reference):hover {
    stroke: hsl(0, 0%, 53%) !important;
  }
`;
export const visualDiffHoverStyleRemoved = css`
  stroke: hsl(0, 0%, 92%) !important;
  &:not(.parent-child-reference):hover {
    stroke: hsl(0, 0%, 70%) !important;
  }
`;
export const visualDiffHoverStyleUnchanged = css`
  stroke: hsl(0, 0%, 65%) !important;
  &:not(.parent-child-reference):hover {
    stroke: hsl(0, 0%, 43%) !important;
  }
`;
